/* import __COLOCATED_TEMPLATE__ from './glm-star-rating.hbs'; */
import Component from '@glimmer/component';
import { htmlSafe } from '@ember/template';
import clsx from 'clsx';

const CLASS_NAME = 'GLM-star-rating';
const STAR_COUNT = 5;

class GlmStarRating extends Component {
  get baseClassName() {
    return CLASS_NAME;
  }

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
    );
  }

  get rating() {
    return this.args.rating ?? 0;
  }

  get starWidths() {
    return [...new Array(STAR_COUNT)].map((_, index) => {
      const widthPercent = Math.min((Math.max((this.rating - index), 0)) * 100, 100);
      return htmlSafe(`width: ${widthPercent}%;`);
    })
  }
}

export default GlmStarRating;
